// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"374":"64dbcad5","453":"3991db68"}[chunkId] + ".chunk.js";
};